import dayjs from "dayjs";

export const formatDateTime = () => dayjs().format("YYYY-MM-DDTHH:mm:ssZ");
